export const Rounding = {
	MIN_ROUND_TO_FULL_HOUR_THRESHOLD: 3600,
	DEFAULT_ROUND_TO_FULL_HOUR_THRESHOLD: 100 * 3600,
};
